import { Icon } from 'framework7-react';
import { FC } from 'react';
import style from './AccountRegistPaymentStyle.module.css';
import { PaymentIcon } from '@/components/uiParts/PaymentIcon/PaymentIcon';
import { PageTemplate } from '@/components/uiParts/Template/PageTemplate/PageTemplate';
import { paymentTypeId } from '@/consts/payment';
import { GmoCardEditParameterResponse } from '@/types/api/payment';

interface AccountRegistPaymentProps {
  status?: string;
  currentCarId?: string;
  GMOCardEditParameters: GmoCardEditParameterResponse['data'];
  handleClickBack: () => void;
  handleClickWithdrawFromBank: () => void;
  handleClickCreditCardPayment: () => void;
  handleClickPaidyPayment?: () => void;
}

export const AccountRegistPayment: FC<AccountRegistPaymentProps> = ({
  currentCarId,
  status,
  GMOCardEditParameters,
  handleClickBack,
  handleClickWithdrawFromBank,
  handleClickCreditCardPayment,
  handleClickPaidyPayment,
}) => {
  return (
    <PageTemplate
      showNavBack
      pageName="AccountRegistPayment"
      title="決済方法を登録"
      handleClickBack={handleClickBack}
    >
      <div className={style['container']}>
        <div
          className={style['list-item']}
          onClick={handleClickWithdrawFromBank}
        >
          <i className={`icon-bank icon`} />
          <p>銀行口座</p>
          <Icon className={style['chevron']} f7="chevron_right" size={24} />
        </div>
        <hr className={style['divider']} />
        <div
          className={style['list-item']}
          onClick={handleClickCreditCardPayment}
        >
          <i className={`icon-credit-card icon`} />
          <p>クレジットカード</p>
          <Icon className={style['chevron']} f7="chevron_right" size={24} />
        </div>
        {handleClickPaidyPayment && (
          <>
            <hr className={style['divider']} />
            <div
              className={style['list-item']}
              onClick={handleClickPaidyPayment}
            >
              <PaymentIcon paymentTypeId={paymentTypeId.PAIDY} />
              <p>あと払い（ペイディ）</p>
              <Icon className={style['chevron']} f7="chevron_right" size={24} />
            </div>
          </>
        )}
      </div>
    </PageTemplate>
  );
};
